import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { MafCommonsModule, MafElementsModule } from 'maf-web';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { ModelServiceModule } from './service/model-service.module';
import { AppService } from './app.service';
import { AppComponent } from './app.component';
import { AutenticacaoComponent } from './autenticacao/autenticacao.component';
import { LoginComponent } from './login/login.component';
import { InicioComponent } from './inicio/inicio.component';
import { ModalConfirmacaoComponent } from './modal/modal-confirmacao/modal-confirmacao.component';
import { GridMosaicoComponent } from './grid-mosaico/grid-mosaico.component';
import { GridMosaicoItemComponent } from './grid-mosaico/grid-mosaico-item.component';

@NgModule({
  imports: [
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    MafCommonsModule,
    MafElementsModule,
    AppRoutingModule,
    ModelServiceModule,
    ToastrModule.forRoot({closeButton: true, progressBar: true, maxOpened: 2})
  ],
  declarations: [
    AppComponent,
    AutenticacaoComponent,
    LoginComponent,
    InicioComponent,
    ModalConfirmacaoComponent,
    GridMosaicoComponent,
    GridMosaicoItemComponent
  ],
  exports: [ RouterModule ],
  providers: [ AppService ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }
